var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AccountImage } from "../../atoms/AccountImage";
import { OverlayHeading, OverlayInfo, OverlayLink, OverlayText, OverlayWrapper, } from "./Overlay.style";
var Overlay = function (_a) {
    var imageSrc = _a.imageSrc, imageAlt = _a.imageAlt, overlayHeading = _a.overlayHeading, overlayText = _a.overlayText, overlayLink = _a.overlayLink, overlayNumber = _a.overlayNumber;
    return (_jsxs(OverlayWrapper, { children: [_jsx(AccountImage, { alt: imageAlt, src: imageSrc }), _jsxs(OverlayInfo, { children: [_jsx(OverlayHeading, __assign({ "data-cy": "overlay-heading" }, { children: overlayHeading })), _jsxs(OverlayText, __assign({ "data-cy": "overlay-subtext" }, { children: [overlayText, _jsx(OverlayLink, __assign({ href: "tel:".concat(overlayNumber) }, { children: overlayLink }))] }))] })] }));
};
export default Overlay;
//# sourceMappingURL=Overlay.js.map